<template>
    <div class="content">
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
            <el-form-item label="成交日期">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                class="w220"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchTime"
              ></el-date-picker>
            </el-form-item>
          
          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        </el-col>
      </el-row>
      <div class="accountCon">
        <div class="btnBox">
          <el-button
            type="primary"
            v-if="!userInfo.shop_id"
            :disabled="!idList.length"
            class="mb10"
            size="mini"
            @click="tapBtn('export')"
          >导出数据</el-button>
          <div v-if="userInfo.shop_id"></div>
         
         <span v-if="is_show_add">
            <el-button
              v-if="clienId && oldId == clienId"
              class="mb10"
              type="primary"
              size="mini"
              round
              @click="tapBtn('add')"
            >新增转诊单</el-button>
         </span>
       
        </div>
        <!--列表-->
        <el-row>
          <el-col :span="24">
            <el-table
              :data="list"
              size="small"
              border
              :cell-style="$style.cellStyle"
              :header-cell-style="$style.rowClass"
              @selection-change="handleSelectionChange"
            >
              <ElTableColumn v-if="!userInfo.shop_id" type="selection" width="50" />
              <ElTableColumn label="订单编号" prop="order_no"  width="160"/>
              <ElTableColumn label="成交日期" prop="deal_time" width="100" />
              <ElTableColumn label="客户名称" prop="customer_name" />
              <ElTableColumn label="客户K3代码" prop="king_no" width="100"/>
              <ElTableColumn label="发起方-门店" prop="shop_name" />
              <ElTableColumn label="发起人" prop="initiator_name" />
              <ElTableColumn label="发起时间" prop="create_time" width="140" />
              <ElTableColumn label="确认方-门店" prop="affirm_shop_name" />
              <ElTableColumn label="确认人" prop="affirm_name" />
              <ElTableColumn label="确认时间" prop="affirm_time" />
              <ElTableColumn label="转诊总额" prop="order_amount" width="90" />
              <ElTableColumn label="本金" prop="pay_amount" width="90" />
              <ElTableColumn label="赠金" prop="gift_amount" width="90" />
              <ElTableColumn label="店转" prop="shop_transfer_amount" width="90" />

              <ElTableColumn label="订单状态" prop="status_text" />
              <ElTableColumn label="收款渠道" prop="order_channel_text" width=""/>
            
              <ElTableColumn label="操作" fixed="right"  width="140" v-if="oldId == clienId">
                <template slot-scope="{ row }">
                  <!-- <el-button type="text"  v-if="row.status == 1 && is_show_affirm"  @click="tapBtn('确认',row)">确 认</el-button> -->
                  <el-button type="text"  @click="tapBtn('detail',row)">查看</el-button>
                </template>
              </ElTableColumn>
            </el-table>
          
            <pagination
              class="page tc mt10"
              :total="page.total"
              :page.sync="page.page"
              :limit.sync="page.limit"
              @pagination="getList"
            />
          </el-col>
        </el-row>
       
  
      </div>
    </div>
    
    
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { referralList, refundExport, lockOrderR } from "@/api/order";
  import { getPayUrl } from "@/api/pay";
  import QRCode from "qrcodejs2";
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class Search {
    start_time = "";
    end_time = "";
    consignee = "";
    shop_name = "";
    low_total = "";
    large_total = "";
    business_type = "";
    order_type = "";
    display_cannel = 0;
  }
  class Options {
    business_type = [
      { id: 1, name: "疤痕" },
      { id: 2, name: "项目" },
      { id: 3, name: "青春痘" },
      { id: 4, name: "护肤品" }
    ];
    order_type = [
      { id: 1, name: "新单" },
      { id: 2, name: "补单" }
    ];
  }
  export default {
    name: "OrderList",
    components: {
      pagination
    },
    props: {
      clienId: {
        type: String,
        default: ""
      },
      detail: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        search: new Search(), // 检索条件
        options: new Options(), // 选项
        page: new Page(), // 分页
        list: [], // 数据展示
        idList: "",
        oldId:"",
        value1: [],
        sum_ben_amount: "noShow",
        sum_zeng_amount: "",
        orderData:{
          refund_order_no:"",
          shop_name:"",
          customer_name:"",
          pay_amount:"",
          order_time:"",
          src:"",
        },
        payData: {
          order_id:"",
          authCode:"",
        }, // 支付信息
        payQrcodePop:false,
        is_show_add:false,
        is_show_affirm:false,
      };
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    mounted() {
      if(this.clienId){
        this.oldId = this.$route.query.id.toString()
      }
      this.getList();
      console.log(this.clienId)
    },
    methods: {
      // 获取列表
      getList(option) {
        if (option == "search") this.page = new Page();
        referralList({
          ...this.search,
          ...this.page,
          type: 3,
          uid: this.clienId ? this.clienId : "",
          status: "-1"
        }).then(res => {
          console.log(res,'res')
          this.is_show_add = res.data.is_show_add
          this.is_show_affirm = res.data.is_show_affirm
          this.list = res.data.list;
          this.page.total = res.data.dataCount;
          if (this.search.end_time) {
            this.sum_ben_amount = res.sum_ben_amount;
            this.sum_zeng_amount = res.sum_zeng_amount;
          } else {
            this.sum_ben_amount = "noShow";
          }
        });
      },
      // 日期搜索
      searchTime(val) {
        if (val) {
          this.search.start_time = val[0];
          this.search.end_time = val[1];
        } else {
          this.search.start_time = "";
          this.search.end_time = "";
        }
      },
      // 点击
      tapBtn(type, row) {
        console.log(this.detail)
        switch (type) {
          case "add":
          const query1 = { clienId: this.clienId, detail: this.detail };
          this.$router.push({ name: "添加转诊单", query:query1 });
          break;
          case "detail":
            const query = {
              id: row.id,
              clienId: this.clienId,
              detail: this.detail,
              activeName: "second1",
              activeTab: "referralList"
              // detail: this.detail
            };
            this.$router.push({ name: "转诊单详情", query });
            break;
          case "export":
            this.hint("导出选中列表", "export");
            break;

          case "affirm":
        
          this.hint("该转诊单", "affirm");
          break;
        
          case "lock":
            if (this.search.end_time) {
              this.hint("锁定选中条件的订单", "lock");
            } else {
              this.$message({
                message: "请选择锁定日期",
                type: "warning"
              });
            }
            break;
        }
      },
      // 提示
      hint(text, type) {
        this.$confirm(`${text},是否确定？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (type == "export") {
              this.getExport();
            } else if(type == 'affirm') {
              this.getLockOrder();
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      //锁单
      getLockOrder() {
        lockOrderR({ ...this.search, type: 3 }).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.getList();
        });
      },
      // 导出
      getExport() {
        refundExport({ id: this.idList, type: 3 }).then(res => {
          window.open(res.data.url);
        });
      },
  
      // 改变表格选中状态
      handleSelectionChange(val) {
        this.idList = val.map(i => {
          return i.id;
        });
      },
  
      // 
      printBtn(type,data){
        this.payData.order_id = data.id;
        this.payData.type = 'WeChat';
  
        getPayUrl({
          // order_id: date.id
          ...this.payData
        }).then(res=>{
          console.log(res.data);
          this.payQrcodePop = true;
          this.orderData.refund_order_no = res.data.refund_order_no;
          this.orderData.shop_name = res.data.shop_name;
          this.orderData.customer_name = res.data.customer_name;
          this.orderData.pay_amount = res.data.pay_amount;
          this.orderData.order_time = res.data.deal_time;
          this.orderData.src = "http://burn.178590.com/images/qrcode-wx.jpg";
          
          // this.printHtml();
          // this.printHtml();
        });
      },
  
      //创建二维码
      qrCodeCreate(url) {
        // console.log('生成支付二维码的链接：'+this.$refs.qrCode);
  
        this.$refs.qrCode.innerHTML = "";
  
        var qrcode = new QRCode(this.$refs.qrCode, {
          // text: 'xxxx', // 需要转换为二维码的内容
          text: url, // 需要转换为二维码的内容
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
  
      printHtml() {
          let bodyHtml = window.document.body.innerHTML;
          let printBox = document.getElementById('printBox').innerHTML;
          window.document.body.innerHTML = printBox;
          // console.log('333');
          window.print();
          location.reload();
          // window.document.body.innerHTML = bodyHtml;
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .accountCon {
    background: #fff;
    padding: 10px 0px 80px;
    .btnBox {
      display: flex;
      justify-content: space-between;
    }
  }
  .reveal {
    text-align: right;
    padding: 20px 0;
    .peril {
      font-weight: bold;
    }
  }
  </style>
  